import { GOLD_PRICE_IS_ACTIVE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GeneralPatchGoldPriceIsActive(data, goldTypeValue, priceTypeValue){
  const api = `${GOLD_PRICE_IS_ACTIVE_API}${goldTypeValue}/${priceTypeValue}/`;
  return axiosHttp.patch(api, data)
}
